export const SET_LOADING = 'SET_LOADING'
export const UPDATE_USERS = 'UPDATE_USERS'
export const DELETE_USER = 'DELETE_USER'
